import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const PAYMENT_REMINDERS_SCHEMA = Object.freeze({
  ENABLED: true,
  OLSON_TIMEZONE: '',
  REMIND_IN: null,
});
export const RECORD = generateSchema(PAYMENT_REMINDERS_SCHEMA);
export const KEYS: any = generateKeys(PAYMENT_REMINDERS_SCHEMA);

export class PaymentReminders extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get enabled(): boolean {
    return this.get(KEYS.ENABLED);
  }

  get olsonTimezone(): string {
    return this.get(KEYS.OLSON_TIMEZONE);
  }

  get remindIn(): List<number> {
    return this.get(KEYS.REMIND_IN);
  }
}
